<template>
    <div>
      <a rel="nofollow" class="EventRow-styles-event-row" :class="(sport.sportId == 1 && match.resultName === '1st half') ? 'EventRow-styles-double-row' : ''" href="javascript:;">
        <div class="EventDateTime-styles-info-cell EventDateTime-styles-info-cell-pre" v-if="!match.onLive">
          <div class="EventDateTime-styles-time EventDateTime-styles-no-date">
            {{ match.startDate | moment('HH:mm', session.timezone) }}
          </div>
        </div>
        <div class="EventDateTime-styles-info-cell EventDateTime-styles-info-cell-live" v-if="match.onLive">
          <div class="EventDateTime-styles-live-date" v-if="match.sport.sportId == 1">
            <span class="notranslate" v-if="match.resultName !== 'Halftime'">{{ periodTimer(match) }}</span>
            <span v-if="match.resultName === 'Halftime'">{{ t['event_periods'][match.resultName] || match.resultName }}</span>
          </div>
          <div class="EventDateTime-styles-live-date" v-if="match.sport.sportId != 1">{{ t['event_periods'][match.resultName] || match.resultName }}</div>
          <span class="EventDateTime-styles-is-live-time EventDateTime-styles-live-time">{{ t.live }}</span>
        </div>
        <div class="EventTeams-styles-event-teams EventTeams-styles-additional-margin" @click="matchOpen(match.matchId)">
          <div class="EventTeams-styles-titles">
            <div class="EventTeams-styles-team">
              <span class="EventTeams-styles-team-title">
                <img width="20" v-if="match.providerId == 2" onerror="this.style.display='none'" :src="'https://statistics.bcapps.net/images/e/m/'+Math.trunc(match.competitor.oneEid / 2000)+'/'+match.competitor.oneEid+'.png'"/>
                <img width="20" v-if="match.providerId == 7" onerror="this.style.display='none'" :src="'https://cdn-d.tentangle.com/jersey/medium/'+match.competitor.oneEid+'.png'"/>
                {{ match.competitor.oneName }} <div v-if="match.data.infos.hasOwnProperty('stats') && match.sport.sportId === 1 && ( (match.data.infos.stats.hasOwnProperty('1st half') && match.data.infos.stats['1st half'].red.home != '0') || (match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].red.home != '0') )" class="redcard"></div>
              </span>
            </div>
            <div class="EventTeams-styles-team">
              <span class="EventTeams-styles-team-title">
                        <img width="20" v-if="match.providerId == 2"  onerror="this.style.display='none'" :src="'https://statistics.bcapps.net/images/e/m/'+Math.trunc(match.competitor.twoEid / 2000)+'/'+match.competitor.twoEid+'.png'"/>
                        <img width="20" v-if="match.providerId == 7" onerror="this.style.display='none'" :src="'https://cdn-d.tentangle.com/jersey/medium/'+match.competitor.twoEid+'.png'"/>
                {{ match.competitor.twoName }} <div v-if="match.data.infos.hasOwnProperty('stats') && match.sport.sportId === 1 && ( (match.data.infos.stats.hasOwnProperty('1st half') && match.data.infos.stats['1st half'].red.away != '0') || (match.data.infos.stats.hasOwnProperty('2nd half') && match.data.infos.stats['2nd half'].red.away != '0') )" class="redcard"></div>
              </span>
            </div>
          </div>
          <div v-if="sport.sportId == 1 && match.resultName === '1st half'" class="EventFirstHalfDetails-styles-event-halftime-details">{{ t['event_periods'][match.resultName] || match.resultName }}</div>
        </div>
        <div class="EventScores-styles-scores">
          <div class="EventScores-styles-score EventScores-styles-score" v-if="match.data.infos.hasOwnProperty('stats') && match.data.infos.stats.hasOwnProperty('1st half')">
            <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-half-time notranslate">
              {{ match.data.infos.stats['1st half'].score.home }}
            </div>
            <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-half-time notranslate">
              {{ match.data.infos.stats['1st half'].score.away }}
            </div>
          </div>
          <div class="EventScores-styles-score EventScores-styles-score" v-if="match.data.score">
            <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-large-current-point notranslate">
              {{ match.data.score.home }}
            </div>
            <div class="EventScores-styles-point EventScores-styles-current-point EventScores-styles-large-current-point notranslate">
              {{ match.data.score.away }}
            </div>
          </div>
        </div>

      <template v-if="list == 1">
          <template v-if="match.sport.sportId == 1 || match.sport.sportId == 9 || match.sport.sportId == 77 || match.sport.sportId == 17">
            <marketOdd :id="1" :odds="match.odds" :match="match" />
            <marketOdd :id="2" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="3" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="4" :odds="match.odds" :match="match"  :hide="$route.params.event" />

          </template>

          <template v-if="match.sport.sportId == 2">
            <marketOdd :id="5" :odds="match.odds" :match="match" />
            <marketOdd :id="6" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="7" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="8" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 3">
            <marketOdd :id="9" :odds="match.odds" :match="match" />
            <marketOdd :id="10" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="11" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="12" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 4">
            <marketOdd :id="13" :odds="match.odds" :match="match" />
            <marketOdd :id="14" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="15" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="16" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 99">
            <marketOdd :id="17" :odds="match.odds" :match="match" />
            <marketOdd :id="18" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="19" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="20" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 19">
            <marketOdd :id="21" :odds="match.odds" :match="match" />
            <marketOdd :id="22" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="23" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="24" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 24">
            <marketOdd :id="25" :odds="match.odds" :match="match" />
            <marketOdd :id="26" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="27" :odds="match.odds" :match="match"  :hide="$route.params.event" />
            <marketOdd :id="28" :odds="match.odds" :match="match"  :hide="$route.params.event" />
          </template>


        </template>
        <template v-if="list == 2">
          <template v-if="match.sport.sportId == 1 || match.sport.sportId == 77 || match.sport.sportId == 17">
            <marketOdd :id="1" :odds="match.odds" :match="match" />
            <marketOdd :id="2" :odds="match.odds" :match="match"  v-if="!$route.params.event" />
            <marketOdd :id="3" :odds="match.odds" :match="match"  v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 2">
            <marketOdd :id="4" :odds="match.odds" :match="match" />
            <marketOdd :id="5" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="6" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 3">
            <marketOdd :id="7" :odds="match.odds" :match="match" />
            <marketOdd :id="8" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="9" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 4">
            <marketOdd :id="10" :odds="match.odds" :match="match" />
            <marketOdd :id="11" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="12" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 9">
            <marketOdd :id="13" :odds="match.odds" :match="match" />
            <marketOdd :id="14" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="15" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 19">
            <marketOdd :id="16" :odds="match.odds" :match="match" />
            <marketOdd :id="17" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="18" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>

          <template v-if="match.sport.sportId == 24">
            <marketOdd :id="19" :odds="match.odds" :match="match" />
            <marketOdd :id="20" :odds="match.odds" :match="match" v-if="!$route.params.event" />
            <marketOdd :id="21" :odds="match.odds" :match="match" v-if="!$route.params.event" />
          </template>
        </template>


        <span id="Event_Stats_Button_31874837" class="EventStatsButton-styles-show-statistics">
          <span class="EventStatsButton-styles-head-to-head"></span>

        </span>
        <div class="EventMarketsIndicator-styles-markets-indicator-wrapper" @click="matchOpen(match.matchId)">
          <span class="EventMarketsIndicator-styles-count notranslate" v-if="!match.isSuspended">{{ match.marketCount }}</span>
          <span class="EventMarketsIndicator-styles-count notranslate" v-if="match.isSuspended">0</span>
          <span class="EventMarketsIndicator-styles-arrow-icon"></span>
        </div>
      </a>
    </div>
</template>

<script>
    import marketOdd from '@/components/sportsbook/marketOdd';
    import sportIcon from '@/components/ui/asset/sportIcon';
    import mainOdds from '@/components/sportsbook/mainOdds'
    import underOverOdds from '@/components/sportsbook/underOverOdds'
    import handicap from '@/components/sportsbook/handicap'
    import winOdds from '@/components/sportsbook/winOdds'
    import setScoreOdds from '@/components/sportsbook/setScoreOdds'
    import Paginate from "vuejs-paginate";
    import favButton from '@/components/sportsbook/favButton'
    import odd from '@/components/sportsbook/odd';
    import PopperVue from '@soldeplata/popper-vue';

    export default {
        name: 'MatchRow',
        components: {PopperVue, marketOdd,mainOdds, underOverOdds, handicap, winOdds, setScoreOdds, favButton, sportIcon, odd},
        props: {list: {type: Number, default: 1}, match: {}, sport: {}, region: {}, extendedMarkets: {}, indx: {default: 0}, selectedOdds: {}},
        data () {
            return {
                t: this.$root.t,
                session: window.session,
                selectedMatch: null,
                showAllMarket: true
            }
        },
        beforeDestroy () {
        },
        watch: {
            matchData: {
                handler() {

                },
                deep: true
            },
        },
        mounted () {
            this.$bus.$on('updatedMatch'+this.match.matchId, (payload) => {
                this.$emit('update-match', null);
            });


        },
        methods: {
            openMatch(m) {
                this.$bus.$emit('openMatchOdd', m);
            },
            matchOpen (id) {
              this.$router.replace({ query: {r: this.$route.query.r, c: this.$route.query.c, page: this.$route.query.page}, params: { event: id } })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .time-wrapper {

    }

    #sr_widget {
        width: 100%;
        display: block;
    }

    .datetime {
        font-size: 11px;
    }

    .redcard {
      float: right;
      border-radius: 2px;
      width: 7px;
      height: 12px;
      background: red;
      margin-left: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/MatchRow.vue